import React from 'react';

import { TouchableOpacity, type TouchableOpacityProps } from 'react-native';

import { Typography } from '../Typography';

type AutocompleteItemProps = {
  placeholder: string;
  id: string;
  highlight?: string;
} & TouchableOpacityProps;

export const AutocompleteItem = ({
  placeholder,
  id,
  highlight,
  ...rest
}: AutocompleteItemProps) => {
  const parts = highlight ? placeholder.split(new RegExp(`(${highlight})`, 'i')) : [placeholder];

  return (
    <TouchableOpacity className="py-4" {...rest}>
      <Typography variant="body2" numberOfLines={1}>
        {parts.map((part, index) => (
          <Typography
            variant={part.toLowerCase() === highlight?.toLowerCase() ? 'bodyHighlight2' : 'body2'}
            key={`${id}_${index}`}>
            {part}
          </Typography>
        ))}
      </Typography>
    </TouchableOpacity>
  );
};
